var path = 'services/error-toast.tpl.html';
var html = "\n<md-toast class=\"tb-error-toast\">\n\t<div class=\"md-toast-content\">\n\t\t  <div class=\"md-toast-text\" ng-bind-html=\"vm.message\"></div>\n\t\t  <md-button ng-click=\"vm.closeToast()\">\n\t\t       {{ 'action.close' | translate }}\n\t\t  </md-button>\n\t</div>\n</md-toast>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/error-toast.tpl.html
// module id = 1520
// module chunks = 1